import { Box, Grid, Typography, Button } from "@material-ui/core";
import React from "react";
import { Localizations } from "../../Shared/sharedTypes";

interface propsType {
    quickCode: string | undefined;
    localizations: Localizations;
    provideFeedback: () => void;
}

export default function ContinueLater({ quickCode, localizations, provideFeedback }: propsType) {
    return (
        <div className="introPhaseContainer">
            <Grid
                style={{ height: "100%", margin: "auto" }}
                lg={4}
                sm={12}
                container
                direction="column"
                alignItems="stretch"
            >
                <Grid
                    item
                    className="transparentBackground"
                    container
                    style={{ flex: 1, backgroundColor: "#85C441AA", padding: "24px 24px" }}
                >
                    <Box p={4} borderRadius={20} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                        <Typography variant="h5" style={{ margin: 0 }}>
                            {localizations.thankYouForParticipating}
                        </Typography>
                        <Box mb={3} mt={3}>
                            <Typography variant="body1" align="center">
                                {localizations.asAReminder}
                            </Typography>
                            <Box textAlign="center" style={{ marginTop: 10 }}>
                                <Button
                                    href={window.location.origin + "/GuideStream/" + quickCode}
                                    variant="contained"
                                    onClick={() => { }}
                                    size="small"
                                    color="primary"
                                >
                                    {localizations.continueNow}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={provideFeedback}
                                    size="small"
                                    color="secondary"
                                    style={{ marginLeft: 10 }}
                                >
                                    {localizations.provideFeedback}
                                </Button>
                            </Box>
                        </Box>

                        <Box textAlign="center">
                            {localizations.PoweredBy} <br />
                            <img
                                src="/images/GuideStream360Logo-dark.png"
                                alt="Powered by Guide Stream 360"
                                style={{
                                    objectFit: "scale-down",
                                    marginTop: 5,
                                    marginBottom: 0,
                                    maxWidth: "85%",
                                    // filter: "drop-shadow(rgba(0, 0, 0, 0.5) 3px 2px 11px)",
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}
